import {
  getParamKeys,
  deepLinkSetSiteIdDropdown,
  deepLinkRedirectToOverview,
  deepLinkRedirectToTab,
  deepLinkRedirectToApp360,
  getCircuit360Keys,
  deepLinkRedirectToCircuit360
} from "./deepLinkContextSwitch";

export const deepLink = (props, BASE_URL, navigate, isUIconvergence) => {
  const handleHashChange = () => {
    const hash = window.location.hash; // Get the current hash 
    const myArray = hash.split("deeplink");
    if (myArray[0] === "#/") {
      const urlParams = new URLSearchParams(myArray[1]);
      //below function helps to extract all parameters from urlParams except BASE_URL.
      const paramKeys = getParamKeys(urlParams, BASE_URL);
      const circuit360Keys = getCircuit360Keys();

      //Checking if only site is passed as parameter
      if (paramKeys.length === 1 && paramKeys[0] === 'site') deepLinkSetSiteIdDropdown(urlParams, props, isUIconvergence);

      //Checking if paramKeys does not include tab parameter to ensure redirect to Overview.
      if (urlParams.size === 2 && !paramKeys.includes('tab')) deepLinkRedirectToOverview(navigate);

      //Checking if only tab is passed as parameter
      if (paramKeys[0] === 'tab') deepLinkRedirectToTab(urlParams, BASE_URL, navigate);

      //Checking if application is the first parameter.
      if (paramKeys[0] === 'application') deepLinkRedirectToApp360(urlParams, navigate, props, isUIconvergence);

      //Checking if the parameters passed are included in circuit360Keys array in any order.
      if (circuit360Keys.includes(paramKeys[0])) deepLinkRedirectToCircuit360(urlParams, navigate, props, isUIconvergence);

    }
  };

  // Listen for hash changes
  window.addEventListener("hashchange", handleHashChange);
  return handleHashChange;
}
